export const progressIntroSteps = [
  {
    element: '#printButton',
    intro: 'Click here to print the WordFlight System Usage School Report.'
  },
  {
    element: '.report',
    intro: 'Unit Progress is where you can view unit progress data for the school.'
  },
  {
    element: '#district-progress-predicted-completion',
    intro: 'See the percentage of students who are likely to complete WordFlight by May 15th.'
  },
  {
    element: '#district-progress-units',
    intro: 'See the percentage of students completing at least one unit per week.'
  },
  {
    element: '.district-report-row:nth-child(3)',
    intro: 'Click the plus sign to view WordFlight unit progress data sorted by teacher. See the teacher’s name, the grades they teach, their school, and the percentage of their students completing one unit per week.'
  },
];